import '@styles/react-components/yotpo.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import YotpoPage from '@root-components/YotpoProductReviews.jsx';

var yotpoWrappers = document.getElementsByClassName("ft-yotpo-page");

for (var i = 0; i < yotpoWrappers.length; i++) {
  ReactDOM.render(
      <YotpoPage {...yotpoWrappers[i].dataset}/>
  , yotpoWrappers[i])
}
